import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AgreementsActionType, AgreementsStore } from './AgreementsReducer.types';

const initialState = Immutable.fromJS({
  agreements: {},
  isFetching: false,
  isFetchingState: false,
  openAgreements: Immutable.Set<string>(),
});

const AgreementsReducer = handleActions<any>(
  {
    REQUEST_AGREEMENT: (state: AgreementsStore) => state.set('isFetching', true),
    RESPONSE_AGREEMENT_FAILURE: (state: AgreementsStore) => state.set('isFetching', false),

    REQUEST_AGREEMENT_STATE: (state: AgreementsStore) => state.set('isFetchingState', true),

    RESPONSE_AGREEMENT_STATE_FAILURE: (state: AgreementsStore) => state.set('isFetchingState', false),

    RESPONSE_AGREEMENT_STATE_SUCCESS: (state: AgreementsStore) => state.set('isFetchingState', false),

    RESPONSE_AGREEMENT_SUCCESS: (state: AgreementsStore, action: AgreementsActionType) => {
      if (action.payload.id === undefined) {
        return state.set('isFetching', false);
      } else {
        return state.set('isFetching', false).setIn(['agreements', action.payload.customId], Immutable.fromJS(action.payload));
      }
    },
    SET_AGREEMENT_OPEN: (state: AgreementsStore, action: AgreementsActionType) => {
      const openAgreements = state.get('openAgreements');
      const id = action.payload.id;
      if (!openAgreements) {
        return state.set('openAgreements', Immutable.Set([id]));
      }

      return state.set('openAgreements', openAgreements.add(id));
    },
    SET_AGREEMENT_CLOSED: (state: AgreementsStore, action: AgreementsActionType) => {
      const openAgreements = state.get('openAgreements');
      const id = action.payload.id;
      if (!openAgreements) {
        return state;
      }

      return state.set('openAgreements', openAgreements.delete(id));
    },
    RESET_AGREEMENTS_STATE: (state: AgreementsStore) => initialState,
  },
  initialState
);

export default AgreementsReducer;
